import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeArExtra from '@angular/common/locales/extra/ar';

/** localStorage key the LanguageService writes the chosen UI language to. */
export const LANGUAGE_STORAGE_KEY = 'exab-lang';

export const ARABIC_LOCALE_ID = 'ar';
export const ENGLISH_LOCALE_ID = 'en-US';

/**
 * Registers the Arabic CLDR data so the built-in date pipe can print Arabic month and day names.
 * Angular formats digits itself, so dates keep Western (Latin) digits in both languages.
 */
export function registerAppLocales(): void {
  registerLocaleData(localeAr, ARABIC_LOCALE_ID, localeArExtra);
}

/**
 * LOCALE_ID factory: follows the stored UI language the same way LanguageService.getCurrentLanguage
 * does (no value means Arabic). LOCALE_ID is read once at bootstrap, so the date locale follows the
 * language the page was loaded in.
 */
export function appLocaleFactory(): string {
  let language: string | null = null;
  try {
    language = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  } catch {
    language = null;
  }
  return language === null || language === 'ar' ? ARABIC_LOCALE_ID : ENGLISH_LOCALE_ID;
}
